import { useEffect, useState } from "react";
import { Button, Flex, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store/config";
import {
  forgotPasswordStart,
  resetForgotPassword,
} from "../../store/features/auth/auth-slice";
import { StyledModal } from "../common/styles";

export const ForgotPasswordModal = (props: {
  openNotification: (message?: string) => void;
  email?: string;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [sentSuccessfully, setSentSuccessfully] = useState<boolean>(false);
  const [forgotPasswordModal, setForgotPasswordModal] =
    useState<boolean>(false);

  const { loading, error, forgotPassword, requestState } = useAppSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (requestState === "finish" && forgotPassword) {
      setSentSuccessfully(true);
    }
  }, [forgotPassword, requestState]);

  useEffect(() => {
    if (!forgotPasswordModal) {
      dispatch(resetForgotPassword());
      setSentSuccessfully(false);
    }
  }, [forgotPasswordModal]);

  useEffect(() => {
    if (error && forgotPasswordModal) {
      props.openNotification();
    }
  }, [error]);

  const sendForgotPassword = () => {
    props.email && dispatch(forgotPasswordStart({ email: props.email }));
  };

  return (
    <>
      <Button
        onClick={() => setForgotPasswordModal(true)}
        style={{ height: 40, width: "min-content", marginTop: 10 }}
      >
        {t("Send Password Reset Email")}
      </Button>
      <StyledModal
        title={sentSuccessfully ? t("Sent Successfully") : t("Reset Password")}
        open={forgotPasswordModal}
        width={400}
        centered
        footer={null}
        onCancel={() => {
          setForgotPasswordModal(false);
        }}
        style={{ direction: "rtl" }}
      >
        <Spin spinning={loading}>
          {sentSuccessfully ? (
            <Flex vertical gap={40} justify="space-between">
              {t("Password reset email sent successfully")}
              <Button
                type="primary"
                onClick={() => setForgotPasswordModal(false)}
              >
                {t("Close")}
              </Button>
            </Flex>
          ) : (
            <Flex vertical gap={40} justify="space-between">
              {t("Are you sure you want to send a password reset email?")}
              <Button type="primary" onClick={sendForgotPassword}>
                {t("Send")}
              </Button>
            </Flex>
          )}
        </Spin>
      </StyledModal>
    </>
  );
};
